import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modal, cursusModal, cart } from 'actions';
import Portal from 'common/components/Portal';
import { Form } from 'react-final-form';
import { t } from 'translates';
import Icon from 'common/components/Icon';
import Field from 'common/components/Form/Field';
import Languages from 'apps/sessions/components/FilterDialog/Languages';
import Daypicker from 'common/components/Form/Daypicker';
import dateFormat from 'dateformat';
import isMobile from 'common/helpers/isMobile';
import scrollIntoView from "scroll-into-view";
import Message from 'common/components/Message';
import storage from 'storage';

const pg_type = window.drupalSettings && window.drupalSettings.pg_type || '';

class CursusModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      cursusSuccess: false,
      translations: []
    };

    this.close = ::this.close;
    this.next = ::this.next;
    this.prev = ::this.prev;
    this.onChangeNow = ::this.onChangeNow;
    this.onSubmit = ::this.onSubmit;
    this.handlePersonsChange = ::this.handlePersonsChange;
    this.handleDayClick = ::this.handleDayClick;
    this.handleLanguageClick = ::this.handleLanguageClick;
    this.showMessage = ::this.showMessage;
    this.sessionValidation = ::this.sessionValidation;
    this.hideError = ::this.hideError;
  }

  componentWillReceiveProps({ cursusModal: {dialog: { page, hash} }}) {
    if (page !== this.state.page) {
      this.setState({
        page
      });
    }
  }

  componentDidUpdate() {
    if (this.state.cursusSuccess) {
      this.setState({
        cursusSuccess: false,
      });
    }
  }

  handlePersonsChange(e) {
    e.preventDefault();

    this.props.actions.cursusModal.changePersons(+e.target.value);

    return false;
  }

  handleLanguageClick(languages) {
    this.props.actions.cursusModal.changeLanguage(languages, this.state.page);

    if (isMobile) {
      scrollIntoView(document.querySelector('.reservation-dialog__col_date'));
    }
  }

  handleDayClick() {
    return (day, { available }) => {
      if (available) {
        const date = dateFormat(day, 'isoDate');
        const currentDate = this.props.cursusModal.dialog.currentPage.date;
        if (currentDate !== date) {
          this.props.actions.cursusModal.changeDate(date);
          if (isMobile) {
            scrollIntoView(document.querySelector('.reservation-dialog__col_time'));
          }
        }
      }
    };
  }

  handleSessionClick(e) {
    this.props.actions.cursusModal.changeSession(e.target.value);
  }

  onSubmit() {
    this.props.actions.cursusModal.submit(this.state.page);
    const {
      cursusModal: {
        id,
        category,
        currency_code,
        original_title,
        productType,
        price,
        tax,
        dialog: {
          persons,
          pages,
        }
      }
    } = this.props;
    const currentSessionObj  = pages[this.state.page - 1].sessions.filter(({ id }) => id === pages[this.state.page - 1].session_id);

    if (currentSessionObj[0].has_translations) {
      if (!this.state.translations.every(element => element === null) && !this.state.translations.includes(currentSessionObj[0].language)) {
        this.showMessage(t("Please choose the same language of interpretation for all sessions.", DT_CURSUS), 'type-error');
        return false;
      }
    }
    let sessions = [];
    pages.forEach((page) => {
      sessions.push(page.session_id);
    });
    const hashString =`${id}_${sessions.join('_')}`;
    const data = {
      id,
      sessions
    };
    const validation = this.sessionValidation(currentSessionObj[0], id, sessions);
    if (!validation) {
      return false
    }
    this.props.actions.cart.addToCart(persons, hashString, 'cursus', data);

    this.setState({
      cursusSuccess: true,
      page:0,
      translations: []
    });

    const item_list_name = '';

    window.dataLayer && dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: currency_code,
        items: [{
          item_name: original_title,
          item_id: id,
          price: price + tax,
          item_category: category,
          item_type: productType,
          quantity: 1,
          course_participants: persons,
          course_language: 'N/A',
          course_date: 'N/A',
          course_time: 'N/A',
          item_list_name: item_list_name || 'N/A',
          item_list_id: pg_type + ' - ' + (item_list_name || 'N/A') + ' - ' + window.location.pathname,
        }]
      }
    });
    this.props.actions.modal.hide('cursus.dialog');
  }

  onChangeNow(e) {
    const {
      cursusModal: {
        id,
        category,
        currency_code,
        original_title,
        productType,
        translation,
        price,
        tax,
        dialog: {
          currentPage,
          page,
          hash,
          persons
        }
      }
    } = this.props;
    let cursusToChange = storage.get(`cart.dialog.cursus.${hash}`);
    cursusToChange.data.sessions[page - 1] = currentPage.session_id;
    const hashString =`${id}_${cursusToChange.data.sessions.join('_')}`;
    const currentSessionObj  = currentPage.sessions.filter(({ id }) => id === currentPage.session_id);
    const validation = this.sessionValidation(currentSessionObj[0], id,cursusToChange.data.sessions, hash);
    if (!validation) {
      return false
    }
    if (translation && currentSessionObj[0].has_translations && translation !== currentSessionObj[0].language) {
      this.showMessage(t("Please choose the same language of interpretation for all sessions.", DT_CURSUS), 'type-error');
      return false;
    }

    const item_list_name = '';

    window.dataLayer && dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: currency_code,
        items: [{
          item_name: original_title,
          item_id: id,
          price: price + tax,
          item_category: category,
          item_type: productType,
          quantity: 1,
          course_participants: persons,
          course_language: 'N/A',
          course_date: 'N/A',
          course_time: 'N/A',
          item_list_name: item_list_name || 'N/A',
          item_list_id: pg_type + ' - ' + (item_list_name || 'N/A') + ' - ' + window.location.pathname,
        }]
      }
    });

    this.props.actions.modal.hide('cursus.dialog');
    this.props.actions.cart.onDeleteSession(hash, true);
    this.props.actions.cart.addToCart(cursusToChange.persons, hashString, 'cursus', cursusToChange.data);
    if (e) {
      e.preventDefault();
    }
    this.props.actions.modal.toggle('cart.dialog');
    document.getElementsByTagName('html')[0].classList.toggle('state--cart-opened');
    this.setState({
      page:0
    });
  }

  next(e) {
    const {
      cursusModal: {
        products,
        id,
        dialog: {
          pages,
          currentPage
        }
      }
    } = this.props;
    e.preventDefault();
    const currentSessionObj  = currentPage.sessions.filter(({ id }) => id === currentPage.session_id);
    let sessions = [];
    pages.forEach((page, index) => {
      if (page && page.session_id && index !== this.state.page - 1) {
        sessions.push(page.session_id);
      }
    });
    sessions = sessions.slice(0, this.state.page);
    const validation = this.sessionValidation(currentSessionObj[0], id, sessions);
    if (!validation) {
      return false
    }
    if (currentSessionObj.length && currentSessionObj[0].has_translations) {
      if (this.state.translations.every(element => element === null) || this.state.translations.includes(currentSessionObj[0].language)) {
        this.setState(state => {
          const translations = state.translations.concat(currentSessionObj[0].language);
          return {
            translations
          };
        });
      } else  {
        this.showMessage(t("Please choose the same language of interpretation for all sessions.", DT_CURSUS), 'type-error');
        return false;
      }
    } else if (this.state.page > 0) {
      this.setState(state => {
        const translations = state.translations.concat(null);
        return {
          translations
        };
      });
    }
    this.setState({
      page: this.state.page + 1
    });
    this.props.actions.cursusModal.changePage(this.state.page, this.state.page + 1);
    if (this.state.page + 1 > pages.length) {
      let checkedLanguages = [];
      products[this.state.page].languages.map(({id}) => {
        checkedLanguages.push(id);
      });
      this.props.actions.cursusModal.changeLanguage(checkedLanguages, this.state.page + 1);
    }
    scrollIntoView(document.querySelector('.reservation-dialog__product-header'));
  }

  prev(e) {
    e.preventDefault();
    const translationArray = this.state.translations.slice(0, this.state.page - 2);
    this.setState({
      page: this.state.page - 1,
      translations: translationArray
    });
    scrollIntoView(document.querySelector('.reservation-dialog__product-header'));
    this.props.actions.cursusModal.changePage(this.state.page, this.state.page - 1);
  }

  get monthsRange() {
    let {
      cursusModal: {
        dialog: {
          persons,
          currentPage: {
            sessions
          }
        },
      }
    } = this.props;

    sessions = sessions.filter(({ available_places }) => available_places >= persons);

    if (!sessions.length) {
      return {
        max: null,
        min: null
      };
    }

    const min = Math.min
      .apply(null, sessions.map(({ date }) => new Date(date).getTime()));
    const max = Math.max
      .apply(null, sessions.map(({ date }) => new Date(date).getTime()));
    const TIMEZONE = new Date().getTimezoneOffset();

    return {
      min: new Date(TIMEZONE > 0 ? min + TIMEZONE * 60000 : min),
      max: new Date(TIMEZONE > 0 ? max + TIMEZONE * 60000 : max),
    };
  }

  convertTimezone(time, full = false) {
    let d = new Date(time);
    const TIMEZONE = d.getTimezoneOffset();
    if (TIMEZONE > 0) {
      d.setTime(d.valueOf() + TIMEZONE * 60000);
    }
    return full ? d : dateFormat(d, 'isoDate');
  }


  close(e) {
    e.preventDefault();
    this.setState({
      page: 0,
      translations: []
    });
    this.props.actions.modal.hide('cursus.dialog');
    return false;
  }

  hideError(e) {
    e.preventDefault();
    this.props.actions.modal.hide('gift.error');
  }

  showMessage(message, type) {
    this.props.actions.modal.show('gift.error', {
      message,
      hideButton: false,
      type,
    });

    const cursusModalTimeout = setTimeout(() => {
      this.props.actions.modal.hide('gift.error');
      clearTimeout(cursusModalTimeout);
    }, 8000);
  }

  sessionValidation(currentSession, id, selectedSessions, hash = undefined) {
    let valid = true;
    const singleSessions = storage.get(`cart.dialog.sessions`);

    if (currentSession && singleSessions.hasOwnProperty(currentSession.id)) {
      this.showMessage(t("This session has already been added to your basket. Please select another session.", DT_CURSUS), 'type-error');
      valid = false;
    }

    let cartCursus = storage.get(`cart.dialog.cursus`);

    if (hash) {
      delete cartCursus[hash]
    }

    let cursusSessions = [];
    let cursusIds = [];
    let cursusFormatedData = {};
    for (const prop in cartCursus) {
      cursusSessions = cursusSessions.concat(cartCursus[prop].data.sessions);
      cursusIds.push(cartCursus[prop].data.id);
      if (!(cartCursus[prop].data.id in cursusFormatedData)) {
        cursusFormatedData[cartCursus[prop].data.id] = [];
      }
      cursusFormatedData[cartCursus[prop].data.id].push(cartCursus[prop].data.sessions);
    }
    if (currentSession && cursusSessions.includes(currentSession.id) && !cursusIds.includes(id)) {
      this.showMessage(t("This session has already been added to your basket. Please select another session.", DT_CURSUS), 'type-error');
      valid = false;
    } else if (cursusFormatedData[id] !== undefined) {
      cursusFormatedData[id].forEach(sessions => {
        selectedSessions.forEach((session, index) => {
          if (index !== 0) {
            if ((sessions[index -1] == selectedSessions[index - 1] && sessions[index] != selectedSessions[index]) ||
                (sessions[index -1] != selectedSessions[index - 1] && sessions[index] == selectedSessions[index])) {
              this.showMessage(t("This session has already been added to your basket. Please select another session.", DT_CURSUS), 'type-error');
              valid = false;
            }
          }

        })
      });
    }
    return valid;
  }


  render() {
    const {
      isOpen,
      cursusModal: {
        title,
        total_products,
        products,
        max_places,
        color,
        dialog: {
          persons,
          currentPage: {
            sessions,
            checkedLanguages,
            date,
            sessionTime,
            session_id
          }
        }
      },
      modal
    } = this.props;

    const sessionTimes = sessions.filter(item => item.date === this.convertTimezone(date, false));
    const sessionsForDatepicker = checkedLanguages.length !== 0 ? sessions : [];


    return (

      <div>
        {!isOpen && (
          <Message
            isOpen={this.state.cursusSuccess}
            messageText={t('Discovery series was added to your selection', DT_CURSUS)}  />
        )}
        {(({ isOpen, message, hideButton, type = 'type-error' }) => isOpen && (
          <div className={'gift-modal-dialog__error-message ' + type}>
            <span dangerouslySetInnerHTML={{ __html: message }} />
            <a
              href="#"
              onClick={this.hideError}
              style={{
                display: hideButton ? 'none' : 'inline-block',
              }}
              className="gift-modal-dialog__error-message-close"
            >
              <Icon name="close" />
            </a>
          </div>
        ))(modal['cursus.error'])}
        <Portal
          id="cursus.dialog"
          className="reservation-dialog__portal"
          onClose={this.close}
          isOpen
        >
          <div className="reservation-dialog reservation-dialog__cursus">
            <header
              className="reservation-dialog__header"
              style={{
                backgroundColor: color,
              }}
            >
              <div className="container">
                <span className="reservation-dialog__title">
                  { title }
                </span>

                <div className="reservation-dialog__close">
                  <button onClick={this.close} />
                </div>
              </div>
            </header>
            <Form onSubmit={this.onSubmit}>
              {({handleSubmit, form }) => (
                <form onSubmit={handleSubmit}>
                  <section className="reservation-dialog__body">
                    {this.state.page === 0 && (
                      <div className="container">
                        <div className="reservation-dialog__col reservation-dialog__col--persons">
                          <div className="reservation-dialog__col-title">
                            <span>
                                {t('Select the number of participants', DT_RESERVATION)}
                            </span>
                          </div>
                          <div className="reservation-dialog__col-body">
                            <Field
                              type="select"
                              name="persons"
                              onChange={this.handlePersonsChange}
                            >
                              {new Array(max_places).fill(1).map((_, i) => (
                                <option
                                  key={Math.random()}
                                  value={i + 1}
                                  className={i + 1 > max_places ? 'unusable' : ''}
                                >
                                  {`${i + 1} ${t('Pers.', DT_RESERVATION)}`}
                                </option>
                              ))}
                            </Field>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.page > 0 && (
                      <Fragment>
                        <div className="reservation-dialog__product-header-wrapper">
                          <div className="container">
                            <div className="reservation-dialog__product-header">
                              <span className="course">{t('Course', DT_CURSUS)}</span>
                              <span className="current-page">{this.state.page}</span>
                              <span className="total-pages">/{products.length}</span>
                              <span className="product-title">
                              {products[this.state.page - 1].title}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="container">
                          <div className="reservation-dialog__col reservation-dialog__col_language bg--gray">
                            <div className="reservation-dialog__col-title">
                              {t('Languages', DT_SESSIONS)}
                            </div>
                            <div className="reservation-dialog__col-body">
                              {products[this.state.page - 1].languages.length && (<Languages
                                list={products[this.state.page - 1].languages}
                                page={this.state.page}
                                checked={checkedLanguages}
                                form={form}
                                actions={this.props.actions}
                                onAddCategory={this.handleLanguageClick}
                              />)}
                            </div>
                          </div>
                          <div className="reservation-dialog__col reservation-dialog__col_date">
                            <div className="reservation-dialog__col-title">
                              {t('Select the date', DT_RESERVATION)}
                            </div>
                            <div className="reservation-dialog__col-body">
                              <Daypicker
                                className="Available"
                                fromMonth={this.monthsRange.min}
                                toMonth={this.monthsRange.max}
                                month={date ? this.convertTimezone(date, true) : this.monthsRange.min}
                                modifiers={{
                                  available: sessionsForDatepicker
                                    .map((s) => {
                                      if (s.available_places >= persons) {
                                        return this.convertTimezone(s.date, true);
                                      }
                                    })
                                }}
                                selectedDays={ this.convertTimezone(date, true) }
                                onDayClick={this.handleDayClick(form)}
                              />
                            </div>
                          </div>
                          <div className="reservation-dialog__col reservation-dialog__col_time bg--gray">
                            <div className="reservation-dialog__col-title">
                              {t('Select the time', DT_RESERVATION)}
                            </div>
                            {date && (
                              <div className="reservation-dialog__col-body sessions">
                                {sessionTimes.map(({ id, time, available_places, course_language }) => {
                                  let defaultTimeHere = false;
                                  if (sessionTime) {
                                    sessionTimes.map(({time}) => {
                                      if (sessionTime == time) {
                                        defaultTimeHere = true;
                                      }
                                    });
                                  }
                                  return (
                                    <Field
                                      key={id}
                                      name="session"
                                      value={id}
                                      type="radio"
                                      defaultChecked={
                                        sessionTime &&
                                        defaultTimeHere ?
                                          sessionTime == time && session_id == id :
                                          sessionTimes[0].id == id
                                      }
                                      label={(
                                        <div>
                                      <span>
                                        { time }
                                      </span>
                                          <span className="sessions__language">{course_language}</span>
                                        </div>
                                      )}
                                      onChange={(e) => { this.handleSessionClick(e) }}
                                      disabled={persons > available_places}
                                    />
                                  )})}
                              </div>
                            )}
                          </div>
                        </div>
                      </Fragment>
                    )}
                  </section>
                  <footer className="reservation-dialog__footer">
                    {this.props.cursusModal.dialog.hash && (
                      <button
                        type="button"
                        className="button"
                        disabled={ date === null}
                        onClick={this.onChangeNow}
                      >
                        <Icon name="checked" />
                        <span>{t('Change session', DT_CURSUS)}</span>
                      </button>
                    )}
                    {this.state.page > 0 && this.props.cursusModal.dialog.hash == null && (
                      <button type="button" className="button button--prev" onClick={this.prev}>
                        <span>{t('Previous', DT_CURSUS)}</span>
                      </button>
                    )}
                    {this.state.page === 0 && this.props.cursusModal.dialog.hash == null && (
                      <button
                        className="button button--next"
                        onClick={this.next}
                        disabled={this.state.page > 0 && date === null}
                      >
                        <span>
                          {t('Next step', DT_CURSUS)}
                        </span>
                        <Icon name="proceed-icon" />
                      </button>
                    )}
                    {this.state.page < total_products && this.state.page > 0 && this.props.cursusModal.dialog.hash == null && (
                      <button
                        className="button button--next"
                        onClick={this.next}
                        disabled={this.state.page > 0 && date === null}
                      >
                        <span>
                          {t('Next', DT_CURSUS)}
                        </span>
                        {this.state.page > 0 && date === null ?  (
                            <Icon name="proceed-icon-black" />
                        ) :
                        (
                          <Icon name="proceed-icon" />
                        )}
                      </button>
                    )}
                    {this.state.page === total_products && this.props.cursusModal.dialog.hash == null && (
                      <button
                        type="submit"
                        className="button button--submit"
                        disabled={ date === null}
                      >
                        <Icon name="checked" />
                        <span>
                        {t('Book now', DT_RESERVATION)}
                      </span>
                      </button>
                    )}
                  </footer>
                </form>
              )}
            </Form>
          </div>
        </Portal>
      </div>
    );
  }
}

export default connect(
  state => ({
    isOpen: state.modal['cursus.dialog'].isOpen,
    cursusModal: state.cursusModal,
    modal: state.modal,
  }),
  dispatch => ({
    actions: {
      modal: bindActionCreators(modal, dispatch),
      cursusModal: bindActionCreators(cursusModal, dispatch),
      cart: bindActionCreators(cart, dispatch),
    },
  }),
)(CursusModal);
